import { lazy } from "react";
import { defineWebModule } from "@tc/ui";
import { manifest } from "./manifest.js";

const SetupPage = lazy(() => import("./web/SetupPage.js").then((m) => ({ default: m.SetupPage })));

/** The setup page lives in the app; the screen itself is a public page (/monitor/<link>, see App.tsx and ./screen). */
export default defineWebModule({ manifest, pages: { "": SetupPage } });
